import client from './client'

export function fetchPublicProfile(username) {
  return client.get(`/api/v1/u/${encodeURIComponent(username)}`)
}
